import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DeleteButton,
  BulkDeleteButton,
} from 'react-admin';
import { TimeField } from '../../../shared/components/TimeField';

interface UserExposuresListProps {
  userId: string;
}

export const UserExposuresList = ({ userId }: UserExposuresListProps) => {
  return (
    <List
      resource="exposures"
      filter={{ userId }}
      perPage={25}
      sort={{ field: 'servedAt', order: 'DESC' }}
      actions={false}
      pagination={false}
      sx={{ '& .RaList-content': { boxShadow: 'none' } }}
    >
      <Datagrid
        bulkActionButtons={
          <BulkDeleteButton label="" mutationMode="pessimistic" />
        }
        size="small"
        rowClick={false}
      >
        <FunctionField
          source="sessionId"
          label="Session ID"
          render={(record: any) => `${record.sessionId.substring(0, 8)}...`}
        />
        <TextField source="storySlug" label="Story Slug" />
        <TimeField source="servedAt" label="Served At" />
        <DeleteButton label="" mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
